import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IStoreModel } from '~/store/types';
import { IClientAllocationActions, IThunkGetOwnClientAllocation } from '../types';

const onGetOwnClientAllocationGU: IThunkGetOwnClientAllocation = thunk(
  async (
    { setClientAllocation }: Actions<IClientAllocationActions>,
    payload,
    { getStoreState },
  ) => {
    const store = getStoreState() as IStoreModel;

    const profile = store.user.current;

    const allocations = await api.clientAllocation
      .getOwnClientAllocationGU(payload)
      .then(r => r.data);

    if (!allocations.length) {
      return;
    }

    const normalizedAllocations = allocations.map(allocation => ({
      id: allocation.id,
      date: allocation.date,
      isArchived: false,
      isOwn: true,
      locationGroups: allocation.locationGroups,
      team: allocation.team,
      user: {
        id: profile.id,
        name: `${profile.firstName} ${profile.lastName}`,
        subRoles: profile.subRoles,
        photo: profile.photo,
        clients: allocation.clients,
      },
    }));

    setClientAllocation(normalizedAllocations);
  },
);

export default onGetOwnClientAllocationGU;
